import { translate } from 'helpers/translateHelper';
import React from 'react';
import { RadioButton } from 'sharedComponents';
import PropTypes from 'prop-types';
const HarmonicsIndicators = (props) => {
    const {
        hasKpi,
        speedHarmonicsSwitch,
        setSpeedHarmonicsSwitch,
        hasHarmonics
    } = props;

    // Always show button, disable if not applicable, show tooltip
    const isDisabled = !hasHarmonics || !hasKpi;
    const getTooltipMessage = () => {
        if (!hasKpi) {
            return translate('ABB.Powertrain.Frontend.noDataAvailableTooltip');
        } else if (!hasHarmonics) {
            return translate('ABB.Powertrain.Frontend.noSpeedInformationTooltip');
        } else {
            return '';
        }
    };
    return (
        <div className='speed-harmonics' title={isDisabled ? getTooltipMessage() : ''}>
            <div className='d-flex align-items-center'>
                <RadioButton
                    id={'speed-harmonics-radio'}
                    checked={speedHarmonicsSwitch}
                    onClick={() => !isDisabled && setSpeedHarmonicsSwitch(!speedHarmonicsSwitch)}
                    label={translate('ABB.Powertrain.Frontend.speedHarmonicsLabel')}
                    medium={true}
                    disabled={isDisabled}
                />
            </div>
        </div>
    );
};

HarmonicsIndicators.propTypes = {
    hasKpi: PropTypes.bool,
    speedHarmonicsSwitch: PropTypes.bool,
    setSpeedHarmonicsSwitch: PropTypes.func,
    hasHarmonics: PropTypes.bool
};

export default HarmonicsIndicators;
